import React from 'react';
import { Form, Formik } from 'formik';
import { Col, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import FormInputField from '../../../common/components/formFields/FormInputField';
import CommonButton from '../../../common/components/CommonButton';
import FormDatePickerField from '../../../common/components/formFields/FormDatePickerField';
import calendarIcon from '../../../assets/img/icons/calendar.svg';

const initialValues = {
  search: '',
  transactionDateFrom: '',
  transactionDateTo: '',
};

const TransactionForm = ({ handleSearch }) => {
  return (
    <>
      <Formik initialValues={initialValues} onSubmit={handleSearch} validateOnBlur={true}>
        {() => (
          <Form noValidate>
            <Row className="d-flex align-items-center">
              <Col md={12}>
                <Row className="d-flex justify-content-between">
                  <Col md={4}>
                    <FormInputField name="search" label="Name" />
                  </Col>
                  <Col md={3}>
                    <FormDatePickerField
                      name="transactionDateFrom"
                      label="Date - From"
                      placeholder="DD/MM/YYYY"
                      icon={calendarIcon}
                      iconClassName="calendar-icon"
                    />
                  </Col>
                  <Col md={3}>
                    <FormDatePickerField
                      name="transactionDateTo"
                      label="Date - To"
                      placeholder="DD/MM/YYYY"
                      icon={calendarIcon}
                      iconClassName="calendar-icon"
                    />
                  </Col>
                  <Col md={2} className="d-flex align-items-end">
                    <CommonButton
                      className="transaction-search-button"
                      type="submit"
                      label="Search"
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );
};
TransactionForm.propTypes = {
  handleSearch: PropTypes.func.isRequired,
};

export default TransactionForm;
